import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityDownloadHealthFolderLocaleModule: LocaleModule = {
  name: "utilityDownloadHealthFolder",
  messages: { en: en, it: it },
};
